import React, {useState, useEffect, useContext} from 'react'
import GridContainer from '../../components/Grid/GridContainer.js'
import {MyAccountContext} from '../../containers/Layout'
import CardSelector from '../../components/CardSelector'
// import {
//     dashboardCardSchema,
//     qualifiedConstantSchema,
//     enrolledConstantSchema,
//     programDropdownDetails
// } from '../../utils/constants.js'
import {
    GlobalSetting,
    HIDE_TECHNICAL_SURVEY_MYACCOUNT_FOR_PRG,
    TOAST_VARIANT,
} from '../../../utils/constants'
import {
    getMyAccountAPIData,
    getClientProgramAPIData,
    getClientEntityProgramList,
} from '../../services/myaccount'
import MarkdownRender from '../../../components/MarkdownRender/index.js'
import SelectDropDown from '../../components/SelectDropDown/index.js'
import {
    Button,
    Dialog,
    Grid,
    DialogTitle,
    DialogContent,
    DialogActions,
    FormHelperText,
    FormControl,
    InputLabel,
    Typography,
    CircularProgress,
    Tooltip,
} from '@material-ui/core'
import Select from 'react-select'
import {FontAwesomeIcon} from '@fortawesome/react-fontawesome'
import {
    customFilterOption,
    prependZero,
    validateURL,
    redirectToProgramRegistration,
} from '../../../utils/utils.js'
import {ToastContext} from '../../../App.js'
import i18next from 'i18next'
import MyAccountReactSelect from '../../../components/MyAccountReactSelect/MyAccountReactSelect.js'

const DialogOrganization = props => {
    return (
        <Dialog
            open={props.showDialogOrg}
            Dialogledby="form-dialog-title"
            fullWidth={true}
            maxWidth={props.maxWidth}
            disableBackdropClick={true}
            aria-labelledby="max-width-dialog-title"
            className="add-practice__dialogbox-wrapper-main"
        >
            <Grid className="add-practice__dialogbox-wrapper">
                <DialogTitle id="form-dialog-title" className="dialog-title">
                    {props.title}
                </DialogTitle>
                <DialogContent className="dialog-content__wrapper">
                    <Grid container spacing={3}>
                        <Grid
                            item
                            xs={12}
                            className={`txt-msg__content ${props.cssClass}`}
                        >
                            <Typography variant="subtitle2">
                                {' '}
                                To add new organization please complete the signup in
                                relative program.
                            </Typography>
                        </Grid>

                        <Grid
                            item
                            xs={12}
                            className={`react-select-grid input-field__main_container ${props.cssClass}`}
                        >
                            <FormControl
                                fullWidth
                                error={props.errorText ? true : false}
                                className="input-field__container"
                            >
                                <InputLabel
                                    required={props.required}
                                    data-shrink={true}
                                    className="react-select-label"
                                >
                                    <span className="react-select-label__text">
                                        {props.fieldName}
                                    </span>
                                </InputLabel>

                                <Select
                                    className="basic-single"
                                    classNamePrefix="select"
                                    // defaultValue={props.defaultValue}
                                    value={props.selectedOptVal}
                                    isDisabled={props.isDisabled}
                                    isLoading={props.isLoading}
                                    isClearable={props.isClearable}
                                    isSearchable={props.isSearchable}
                                    name={props.name}
                                    isMulti={props.multiSelect}
                                    options={props.allProgramList}
                                    onChange={props.handleProgramChange}
                                    placeholder={props.placeholder}
                                    filterOption={customFilterOption}
                                    theme={theme => ({
                                        ...theme,
                                        borderRadius: 0,
                                    })}
                                    closeMenuOnSelect={props.multiSelect ? false : true}
                                />
                                <FormHelperText>{props.errorText}</FormHelperText>
                            </FormControl>
                        </Grid>
                    </Grid>
                </DialogContent>
                <DialogActions className="dialog-action__wrapper">
                    <Button type="submit" variant="" onClick={props.handleCloseDialogOrg}>
                        Close
                    </Button>
                    <Button
                        type="submit"
                        variant="outlined"
                        color="primary"
                        onClick={props.handleSubmitOrg}
                    >
                        Add
                    </Button>
                </DialogActions>
            </Grid>
        </Dialog>
    )
}

const Dashboard = props => {
    const {showToast} = useContext(ToastContext)
    const isMultipractice = GlobalSetting.IS_MULTIPRACTICE
    const [open, setOpen] = useState(false)
    const {
        routeObject,
        setrouteObject,
        clientObject,
        setClientObject,
        resourceObject,
        accountEntity,
        enrolledObject,
        setenrolledProgram,
        qualifiedObject,
        setqualifiedProgram,
        setPracticeObject,
        clientProgramObject,
        setClientProgramObject,
        clientProgramSelectedObject,
        setClientProgramSelectedObject,
        myAccountSchema,
        setOrgSelectRefresh,
        OrgSelectRefresh,
        PrgSelectRefresh,
        setPrgSelectRefresh,
    } = useContext(MyAccountContext)

    const [demographicsObject, setdemographicsObject] = useState({})
    const [reportCountObject, setreportCountObject] = useState({})
    const [allProgramList, setAllProgramList] = useState([])
    const [selectedOptVal, setSelectedOptVal] = useState({})
    const [btnStatus, setBtnStatus] = useState(false)
    const [isAddNewOrgAccess, setIsAddNewOrgAccess] = useState(true)
    const [selectedClientProgramObject, setSelectedClientProgramObject] = useState({})

    //State to maintain which progam should be filtered out from ALL PROGRAM list for current selected client entity
    const [filterProgramId, setFilterProgramID] = useState(null)

    useEffect(() => {
        accessController()
    }, [])

    useEffect(() => {
        if (
            clientProgramSelectedObject.length > 0 &&
            clientProgramObject.programs.length > 0
        ) {
            let selectedObject = clientProgramObject.programs.filter(t => {
                if (t.obj.acronym === clientProgramSelectedObject) return t.obj
            })
            // console.log('logged', selectedObject[0])
            setSelectedClientProgramObject(
                (selectedObject.length > 0 && selectedObject[0]) || {}
            )
        }
    }, [clientProgramSelectedObject, clientProgramObject.programs])

    useEffect(() => {
        accessController()
    }, [resourceObject])

    useEffect(() => {
        if (clientObject['cliententityid'] !== 0) {
            const callApi = async () => {
                try {
                    const response = await getClientEntityProgramList(
                        clientObject['cliententityid']
                    )
                    const resultObj = response.resultObject
                    const vendorPrgId = resultObj ? resultObj.vendorclientprogramid : null
                    if (vendorPrgId) {
                        let selectedObject = clientProgramObject.programs.filter(
                            t => t.obj.value === resultObj.firstclientprogramid
                        )
                        setFilterProgramID(vendorPrgId)
                        if (selectedObject.length > 0)
                            setSelectedClientProgramObject(selectedObject[0])
                    } else setFilterProgramID(null)
                } catch (err) {
                    console.log(
                        '🚀 ~ file: Dashboard.js ~ getClientEntityProgramList line 210 ~ callApi ~ err',
                        err
                    )
                    setFilterProgramID(null)
                }
            }
            callApi()
            setAllProgramList([])
            refreshDashboardCards(clientObject['cliententityid'])
        }
    }, [clientObject] && [clientObject['cliententityid']])

    useEffect(() => {
        if (
            enrolledObject.subscribedprogram &&
            enrolledObject.subscribedprogram.length > 0
        )
            addNewOrgDropdownBind(enrolledObject.subscribedprogram)
    }, [enrolledObject])

    useEffect(() => {
        if (
            enrolledObject.subscribedprogram &&
            enrolledObject.subscribedprogram.length === 0
        )
            if (
                qualifiedObject.availableprogram &&
                qualifiedObject.availableprogram.length > 0
            )
                addNewOrgDropdownBind(qualifiedObject.availableprogram)
    }, [qualifiedObject])

    const addNewOrgDropdownBind = program => {
        setBtnStatus(true)
        let dropDownData = []
        program.forEach(element => {
            //Filter to avoid virtual programs in AddOrganization Select
            if (element.programhost1) {
                dropDownData.push({
                    value: element.clientprogramid,
                    label: element.programname,
                    obj: {...element},
                })
            }
        })
        if (dropDownData && dropDownData.length) {
            setAllProgramList(allProgramList => {
                dropDownData = allProgramList.concat(dropDownData)
                const filteredProg = dropDownData.reduce((acc, current) => {
                    const x = acc.find(item => item.value === current.value)
                    if (!x) return acc.concat([current])
                    else return acc
                }, [])
                return filteredProg
            })
        }
        setBtnStatus(false)
    }

    const accessController = () => {
        if (resourceObject['isPolicyBased']) {
            if (
                resourceObject['resource'] &&
                resourceObject['resource'].resource === 'MyAccount Application' &&
                resourceObject['resource'].childs &&
                resourceObject['resource'].childs.length > 0
            ) {
                let addNewOrgAccess = resourceObject['resource'].childs.filter(
                    value => value.resource === 'AddNewOrg'
                )

                if (addNewOrgAccess && addNewOrgAccess.length > 0) {
                    let action = addNewOrgAccess[0].actions
                    let actions = action.split(',')

                    actions.includes('View')
                        ? setIsAddNewOrgAccess(true)
                        : setIsAddNewOrgAccess(false)
                } else {
                    setIsAddNewOrgAccess(false)
                }
            } else {
                setIsAddNewOrgAccess(false)
            }
        }
    }

    const cardHandler = obj => {
        switch (obj.actiontype.toLowerCase()) {
            case 'details':
            case 'manage':
            case 'knowmore':
                setrouteObject({
                    ...routeObject,
                    key: obj.key,
                    actiontype: obj.actiontype,
                    logo: obj.logo,
                    backrouter: null,
                    // dashboard: obj.dashboardurl || null,
                    payment: obj.paymenthistory,
                    previousyearpayment: obj.previousyearpayment,
                    agreements: obj.agreements,
                    registryinfo: obj.registryinfo,
                    providertab: obj.cliniciandetails,
                    signup: obj.signup,
                    dashboard: obj.dashboard,
                })

                setClientObject({
                    ...clientObject,
                    clientprogramid: obj.clientprogramid || 0,
                    clientprogramname: obj.clientprogramname || '',
                    programid: obj.programid || 0,
                    programhost: obj.programhost || '',
                    mipsdateexpired: obj.mipsdateexpired,
                    mipsdateexpiredmessage: obj.mipsdateexpiredmessage,
                })
                break

            default:
                break
        }
    }

    const getDemographics = key => {
        setdemographicsObject({})
        const callApi = async () => {
            const data = await getMyAccountAPIData(
                'cliententity/accountdemographics',
                {},
                key
            )
            if (Object.entries(data).length > 0) {
                setPracticeObject({
                    practiceId: data.practiceid,
                    practicename: data.cliententityname,
                })
                setdemographicsObject(data)
            } else setdemographicsObject({})
        }
        callApi()
    }

    const getCount = key => {
        setreportCountObject({})
        const callApi = async () => {
            const data = await getMyAccountAPIData(
                'cliententity/accountreportcount',
                {},
                key
            )
            if (Object.entries(data).length > 0) setreportCountObject(data)
            else setreportCountObject({})
        }
        callApi()
    }

    const getSubscribedPrograms = key => {
        setBtnStatus(true)
        setenrolledProgram({
            subscribedprogram: [],
        })
        const callApi = async () => {
            const data = await getMyAccountAPIData(
                'cliententity/subscribedprogram',
                {},
                key
            )
            if (Object.entries(data).length > 0) {
                if (data.error && Object.keys(data.error).length > 0)
                    setenrolledProgram({
                        subscribedprogram: [],
                    })
                else {
                    setenrolledProgram(data)
                    if (data.subscribedprogram && data.subscribedprogram.length > 0) {
                        if (data.subscribedprogram[0].vendoraccess === false) {
                            setPrgSelectRefresh(true)
                            refreshDashboardCards(clientObject['cliententityid'])
                            // getSubscribedPrograms({
                            //     'client-entity-id': clientObject['cliententityid'],
                            // })
                        }
                    }
                }
            } else
                setenrolledProgram({
                    subscribedprogram: [],
                })

            Object.entries(key).length > 0 && getAvailablePrograms(key)
        }
        callApi()
    }

    const getAvailablePrograms = key => {
        setqualifiedProgram({
            availableprogram: [],
        })
        const callApi = async () => {
            const data = await getMyAccountAPIData(
                'cliententity/availableprogram',
                {},
                key
            )
            if (Object.entries(data).length > 0) {
                if (data.error && Object.keys(data.error).length > 0)
                    setqualifiedProgram({
                        availableprogram: [],
                    })
                else setqualifiedProgram(data)
            } else
                setqualifiedProgram({
                    availableprogram: [],
                })

            setBtnStatus(false)
        }
        callApi()
    }

    const getSignUpURL = program => {
        const callApi = async () => {
            const data = await getClientProgramAPIData(
                'user/cliententity/enrol?isnewpracticeassociation=true',
                {},
                {
                    'client-entity-id': clientObject.cliententityid,
                    'client-program-id': program.clientprogramid,
                }
            )

            if (data) {
                if (Object.entries(data).length > 0)
                    redirectToProgramRegistration(data.registrationurl, '')
                else
                    showToast({
                        open: true,
                        variant: TOAST_VARIANT.ERROR,
                        message: i18next.t('myaccount.available.enroll.error'),
                    })
            }
        }
        callApi()
    }

    const refreshDashboardCards = Key => {
        getDemographics({'client-entity-id': Key})
        getCount({'client-entity-id': Key})
        getSubscribedPrograms({'client-entity-id': Key})
    }

    const handleAddOrganization = () => {
        // console.log('allProgramList[0].obj', allProgramList[0].obj)
        if (clientProgramSelectedObject === 'all') {
            // console.log('allProgramList[0].obj', allProgramList[0].obj)
            if (allProgramList.length > 1) setOpen(true)
            else if (allProgramList.length === 1) getSignUpURL(allProgramList[0].obj)
            else
                showToast({
                    open: true,
                    variant: TOAST_VARIANT.ERROR,
                    message: i18next.t('myaccount.demographic.program.error'),
                })
        } else {
            const activeProgram = allProgramList.filter(
                p =>
                    p.obj.acronym.toLowerCase() ===
                    clientProgramSelectedObject.toLowerCase()
            )
            // console.log(activeProgram, 'activeProgram')
            activeProgram && activeProgram[0] && getSignUpURL(activeProgram[0].obj)
        }
    }

    const handleCloseDialogOrg = e => setOpen(false)

    const handleSubmitOrg = e => {
        getSignUpURL(selectedOptVal)
        setSelectedOptVal({})
        setOpen(false)
    }

    const handleProgramChange = option => setSelectedOptVal(option ? option.obj : {})

    const updateDataInCards = input => {
        //update masterschema with apidata
        const indexObj = input.value
        const caseKey = input.case
        let count = 0
        let errorFlag = false
        switch (caseKey.toLowerCase()) {
            case 'section1':
                count = 0
                errorFlag = false
                if (reportCountObject.error) {
                    count = 0
                    errorFlag = true

                    indexObj[1]['errorHandle'] =
                        count > 0 ? reportCountObject.providerdetails : errorFlag
                } else {
                    count = Object.entries(reportCountObject).length
                }
                indexObj[0]['data'] = demographicsObject
                indexObj[0]['cardClickHandler'] = {cardHandler}
                indexObj[1]['data'] = count > 0 ? reportCountObject.users : null
                indexObj[1]['cardClickHandler'] = {cardHandler}
                break

            case 'section2':
                if (reportCountObject.error) {
                    count = 0
                    errorFlag = true
                    indexObj[0]['errorHandle'] =
                        count > 0 ? reportCountObject.providerdetails : errorFlag
                    indexObj[1]['errorHandle'] =
                        count > 0 ? reportCountObject.providerdetails : errorFlag
                    indexObj[2]['errorHandle'] =
                        count > 0 ? reportCountObject.providerdetails : errorFlag
                } else count = Object.entries(reportCountObject).length

                indexObj[0]['data'] = count > 0 ? reportCountObject.providerdetails : null
                indexObj[1]['data'] =
                    count > 0
                        ? clientObject.entitytypeid === 3
                            ? reportCountObject.eddetails
                            : reportCountObject.locationdetails
                        : null
                indexObj[2]['data'] =
                    count > 0 ? reportCountObject.technicaldetails : null

                indexObj[0]['cardClickHandler'] = {cardHandler}
                indexObj[1]['cardClickHandler'] = {cardHandler}
                indexObj[2]['cardClickHandler'] = {cardHandler}
                break

            case 'subscribed':
                let subscribedSchema
                const arrayOfSubscribed = []
                if (enrolledObject.subscribedprogram.length > 0) {
                    enrolledObject.subscribedprogram.forEach(schema => {
                        subscribedSchema = {}
                        subscribedSchema = JSON.parse(
                            JSON.stringify(
                                myAccountSchema.enrolledConstantSchema &&
                                    myAccountSchema.enrolledConstantSchema
                            )
                        )
                        subscribedSchema.data = schema
                        subscribedSchema.columnMedia[0]['imageUrl'] = schema.logo
                        arrayOfSubscribed.push(subscribedSchema)
                    })
                    arrayOfSubscribed.map(e => (e['cardClickHandler'] = {cardHandler}))
                    input.value = []
                    input.value = arrayOfSubscribed
                } else {
                    // subscribedSchema = {}
                    // subscribedSchema = JSON.parse(JSON.stringify(enrolledConstantSchema))
                    // subscribedSchema['cardClickHandler'] = { cardHandler }
                    input.value = []
                    // input.value.push(subscribedSchema)
                }

                break
            case 'available':
                let availableSchema
                const arrayOfAvailable = []
                if (qualifiedObject.availableprogram.length > 0) {
                    qualifiedObject.availableprogram.forEach(schema => {
                        availableSchema = {}
                        availableSchema = JSON.parse(
                            JSON.stringify(
                                myAccountSchema.qualifiedConstantSchema &&
                                    myAccountSchema.qualifiedConstantSchema
                            )
                        )
                        availableSchema.data = schema
                        availableSchema.columnMedia[0]['imageUrl'] = schema.logo
                        arrayOfAvailable.push(availableSchema)
                    })
                    arrayOfAvailable.map(e => {
                        e['cardClickHandler'] = {cardHandler}
                        e['subscribeProgramFun'] = {getSubscribedPrograms}
                        e['avilableProgramFun'] = {getAvailablePrograms}
                    })
                    input.value = []
                    input.value = arrayOfAvailable
                } else {
                    // availableSchema = {}
                    // availableSchema = JSON.parse(JSON.stringify(qualifiedConstantSchema))
                    // availableSchema['cardClickHandler'] = { cardHandler }
                    // availableSchema['subscribeProgramFun'] = { getSubscribedPrograms }
                    // availableSchema['avilableProgramFun'] = { getAvailablePrograms }
                    input.value = []
                    // input.value.push(availableSchema)
                }
                break

            case 'headerrow':
                input.value = ''
                switch (input.valueType.toLowerCase()) {
                    case 'available':
                        const aLength = qualifiedObject.availableprogram.length || 0
                        if (aLength > 0)
                            input.value =
                                'Available Programs (' + prependZero(aLength) + ')'
                        break

                    case 'subscribed':
                        const sLength = enrolledObject.subscribedprogram.length || 0
                        if (sLength > 0)
                            input.value =
                                'Subscribed Programs (' + prependZero(sLength) + ')'
                        break

                    default:
                        break
                }
                break

            default:
                return null
        }
    }

    if (
        Object.entries(
            myAccountSchema.dashboardCardSchema &&
                myAccountSchema.dashboardCardSchema.rows
        ).length > 0
    ) {
        myAccountSchema.dashboardCardSchema.rows.forEach((input, key) => {
            if (clientObject) {
                if (clientObject.entitytypeid === 3) {
                    //Physician Group
                    switch (input.case.toLowerCase()) {
                        case 'section2':
                            const valueED = input.value[1]
                            const valueTechnical = input.value[2]
                            if (valueED.componentType === 'LocationCard') {
                                valueED.componentType = 'EDCard'
                                valueED.headerText = '<h4>EMERGENCY DEPARTMENTS</h4>'
                                valueED.label.Total = 'Total EDs'
                                valueED.icon = 'credit-card-front'
                            }
                            valueTechnical.isHidden = true
                            break

                        default:
                            break
                    }
                } else {
                    switch (input.case.toLowerCase()) {
                        case 'section2':
                            const valueED = input.value[1]
                            const valueTechnical = input.value[2]
                            if (valueED.componentType === 'EDCard') {
                                valueED.componentType = 'LocationCard'
                                valueED.headerText = '<h4>LOCATIONS</h4>'
                                valueED.label.Total = 'Total Locations'
                                valueED.label.Active = 'Active'
                                valueED.label.Inactive = 'Inactive'
                                valueED.icon = 'map-marked-alt'
                            }
                            valueTechnical.isHidden = false
                            break

                        default:
                            break
                    }
                }
                updateDataInCards(input)
            }
        })
    }

    const myaccountSchemaCards = HIDE_TECHNICAL_SURVEY_MYACCOUNT_FOR_PRG.includes(
        clientProgramSelectedObject.toLowerCase()
    )
        ? myAccountSchema.dashboardCardSchema.rows.map(p => {
              if (p.case === 'Section2') {
                  p.value = p.value.map(c => {
                      if (c.componentType === 'TechnicalCard') {
                          c.isHidden = true
                      }
                      return c
                  })
              }
              return p
          })
        : myAccountSchema.dashboardCardSchema.rows

    return (
        <div className="dashboard-page__wrapper">
            <MarkdownRender value="<span style='color: #17185A; font-weight: 500; font-size: xx-large; font-family: Roboto,sans-serif;'> My Account</span>" />
            {isMultipractice && (
                <div className="multi-pract-drop__wrapper">
                    <Grid container spacing={2}>
                        <Grid item xs={12} md={4} lg={4}>
                            <MyAccountReactSelect
                                data={clientProgramObject.programs.filter(
                                    p => p.value !== filterProgramId
                                )}
                                fieldValue={selectedClientProgramObject}
                                onChange={item => {
                                    setSelectedClientProgramObject(item)
                                    setClientProgramSelectedObject(item.acronym)
                                }}
                                isClearable={false}
                                fieldName="Program"
                                placeholder="Select Program"
                                fetchData={false}
                                multiSelect={false}
                                endPoint="myaccountprogramentity"
                                icon={
                                    myAccountSchema.programDropdownDetails.isShowInfoIcon
                                        ? myAccountSchema.programDropdownDetails.icon
                                        : ''
                                }
                            />
                        </Grid>
                        <Grid item xs={12} md={4} lg={4}>
                            {isMultipractice && (
                                <SelectDropDown
                                    fieldName="Organization"
                                    placeholder="Select Organization"
                                    cssClass="select-practice__drpdn"
                                    endPoint="accountcliententity"
                                    data={accountEntity || []}
                                    isClearable={false}
                                    isSearchable={true}
                                />
                            )}
                        </Grid>
                        <Grid item xs={12} md={4} lg={4} className="right-btn__container">
                            <Button
                                variant="outlined"
                                color="primary"
                                name="addorganization"
                                startIcon={
                                    props.actionicon && (
                                        <FontAwesomeIcon
                                            icon={['fal', props.actionicon]}
                                        ></FontAwesomeIcon>
                                    )
                                }
                                onClick={handleAddOrganization}
                                disabled={isAddNewOrgAccess ? btnStatus : true}
                            >
                                {isAddNewOrgAccess && btnStatus && (
                                    <CircularProgress size={24} />
                                )}
                                Add new organization
                            </Button>
                        </Grid>
                    </Grid>
                </div>
            )}
            <GridContainer>
                {myaccountSchemaCards.map((schema, index) => {
                    return <CardSelector key={'card' + index} {...schema}></CardSelector>
                })}
            </GridContainer>

            <DialogOrganization
                showDialogOrg={open}
                maxWidth="md"
                title="Add New Organization"
                handleSubmitOrg={handleSubmitOrg}
                allProgramList={allProgramList}
                handleCloseDialogOrg={handleCloseDialogOrg}
                fieldName="Select Program"
                placeholder="Select Program"
                handleProgramChange={handleProgramChange}
                //dialogFormData={setdialogFormData}
            />
        </div>
    )
}

export default Dashboard
